/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Create new event group" |
*
* @param {Create_New_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_new_event_group = /** @type {((inputs?: Create_New_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un nouveau groupe d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Ereignisgruppe erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un nuovo gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новую группу событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nuevo grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントグループを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट समूह बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar novo grupo de eventos")
	return /** @type {LocalizedString} */ ("Create new event group")
});